import { IconComponentType, IconWrapper } from './icon-wrapper'

const IconPlus: IconComponentType = ({ className }) => {
  return (
    <IconWrapper className={className}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0008 4.7998L12.0008 19.1998M19.2008 11.9998L4.80078 11.9998"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </IconWrapper>
  )
}


export default IconPlus